import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_established_grievance_handling_and_dispute_re'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_established_grievance_handling_and_dispute_re',
  name: 'Does the facility have established grievance handling and dispute resolution procedures?',
  description:
    "The intent of this question is to understand if there are communications systems in place for handling complaints and grievances.\r\r\n\r\r\nExample of communications systems for handling complaints and grievances might include:\r\r\n\r\r\nPhysical suggestion boxes, phone numbers/websites workers can use, open door policy (i.e. direct in-person communication with management), etc.\r\r\n\r\r\nGrievances are complaints raised by one or more workers (or a trade union) against the facility regarding employment relations, working conditions, or the employer's policies or practices that concern existing right(s) (e.g. under the law, collective agreement, employment contract, work rules or internal regulations). \r\r\n\r\r\nA collective dispute is a disagreement between a group of workers, usually but not necessarily represented by a trade union, and an employer or group of employers over existing rights or future interests.\r\r\n\r\r\nAn individual dispute is a disagreement between a single worker and the employer usually over existing rights, and can also include situations in which a number of workers disagree with their employer over the same issue, but where each worker acts as an individual.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'gr-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12870,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
